<template>
  <v-container fluid class="pa-0 px-3 pt-3">
    <v-flex class="pb-4" v-for="component in components" :key="component.id">
      <v-layout row wrap fluid justify-space-between class="mx-2 primary--text">
        <font-awesome-icon
          class="secondary--text mr-3 mt-1"
          size="lg"
          :icon="getIcon(component)"
        >
        </font-awesome-icon>
        <v-flex grow>
          <h2 class="width-add-case-btn" v-if="component.bucketGroupId">
            <PageTitle
              :pageTitle="component.label"
              :taskCount="component.taskCount"
            ></PageTitle>
            <div class="add-case-btn">
              <v-tooltip top color="secondary" v-if="component.bucketGroupId">
                <v-btn slot="activator" icon class="ma-0 mr-0" to="/" v-on:click="addCase(component.bucketGroupId)">
                  <v-icon color="success">add_circle</v-icon>
                </v-btn>
                <span>Add a new case</span>
              </v-tooltip>
            </div>
          </h2>
          <h2 v-if="!component.bucketGroupId">
            <PageTitle
              :pageTitle="component.label"
              :taskCount="component.taskCount"
            ></PageTitle>
          </h2>
        </v-flex>
        <v-flex shrink pt-1 pr-3 v-if="component.tasksOverdue">
          <h4 class="font-weight-bold error--text">
            {{ component.tasksOverdue }} Overdue
          </h4>
        </v-flex>
        <v-flex shrink>
          <v-btn class="ma-0" color="secondary" v-if="component.link"
            >View all</v-btn
          >
        </v-flex>
      </v-layout>
      <v-layout mt-3 row wrap fluid>
        <component
          :is="getComponent(component.type)"
          :bucketGroupId="component.bucketGroupId"
          :teamId="component.teamId"
        />
      </v-layout>
      <v-spacer></v-spacer>
    </v-flex>
  </v-container>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import CaseHistory from "@/components/homepage/CaseHistory";
import Tasks from "@/components/homepage/Tasks";
import Notifications from "@/components/homepage/Notifications";
import BucketGroup from "@/components/homepage/BucketGroup";
import MetricPanel from "@/components/homepage/MetricPanel";
import { mapState } from "vuex";

export default {
  name: "homepage-layout",
  components: { PageTitle, CaseHistory, Notifications, BucketGroup },
  computed: {
    ...mapState({
      screenLayouts: (state) =>
        state && state.accounts && state.accounts.screenLayouts
          ? state.accounts.screenLayouts
          : [],
      caseTypes: (state) => state.caseTypes.all,
    }),
    components() {
      if (this.screenLayouts && this.screenLayouts.length > 0) {
        return this.orderLayouts();
      } else {
        return [];
      }
    },
  },
  methods: {
    addCase(bucketGroupId) {
      this.$store.dispatch("addCaseViaBucketId", bucketGroupId);
    },
    async deleteLayoutItem(id) {
      await this.$store.dispatch("deleteScreenLayoutItem", { id: id });
    },
    orderLayouts() {
      if (this.screenLayouts && this.screenLayouts.length > 0) {
        return this.screenLayouts.sort(function (a, b) {
          if (a.position < b.position) {
            return -1;
          }
          if (a.position > b.position) {
            return 1;
          }
          return 0;
        });
      }
    },
    getComponent(component) {
      switch (component) {
        case "caseHistory":
          return CaseHistory;
        case "notifications":
          return Notifications;
        case "tasks":
          return Tasks;
        case "bucketGroup":
          return BucketGroup;
        case "teamTasks":
          return Tasks;
        case "metricPanel":
          return MetricPanel;
      }
    },
    getIcon(component) {
      let icon = "file";
      if (component.type === "bucketGroup" || component.type === "metricPanel") {
        this.caseTypes.forEach((caseType) => {
          if (caseType.bucketGroups) {
            caseType.bucketGroups.forEach((group) => {
              if (group.id === component.bucketGroupId) {
                icon = caseType.iconCode;
              }
            });
          }
        });
      } else {
        switch (component.type) {
          case "caseHistory":
            icon = "history";
            break;
          case "notifications":
            icon = "bell";
            break;
          case "tasks":
            icon = "tasks";
            break;
          case "teamTasks":
            icon = "tasks";
            break;
        }
      }
      return icon;
    },
  },
};
</script>
<style>
.width-add-case-btn {
  padding-right: 50px;
  float: left;
  position: relative;
}

.width-add-case-btn.two-btns {
  padding-right: 87px;
}

.add-case-btn {
  position: absolute;
  top: -5px;
  right: 8px;
}
</style>